import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vex-update-phone-thank-you',
  templateUrl: './update-phone-thank-you.component.html',
  styleUrls: ['./update-phone-thank-you.component.scss']
})
export class UpdatePhoneThankYouComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
